/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Entry/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Entry({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/MedicalTab/Content/Content/MedicalHistoryStatus/Content/Entry"
  
}) {
let entryItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'entry_item',
path: 'isFirst',
})
let entryNameValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'name',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let entryValueValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'value',
})
  return (<React.Fragment
>
<div
  data-testid="Entry.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 weight="medium"
 color={dtColorsWhite}
 data="entry.name"
 text={entryNameValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 color={dtColorsWhite}
 marginRight={4}
 text=":"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 color={dtColorsWhite}
 data="entry.value"
 text={entryValueValueData}
/>
</div>
{children}
</React.Fragment>)
}